<template>
    <path fill-rule="evenodd" d="M16.023 21c-1.1 0-2.023.912-2.023 2s.923 2 2.023 2c1.06 0 2.024-.912 1.975-1.952A1.963 1.963 0 0 0 16.023 21zm15.198 6.059a5.886 5.886 0 0 0 .013-5.829l-10.3-18.295C19.913 1.093 18.071 0 16.005 0 13.941 0 12.1 1.1 11.08 2.928L.765 21.244a5.933 5.933 0 0 0 .02 5.862C1.81 28.914 3.644 30 5.697 30h20.577c2.059 0 3.907-1.1 4.946-2.941zm-2.236-1.323c-.573 1.012-1.586 1.613-2.717 1.613H5.692a3.053 3.053 0 0 1-2.684-1.579A3.263 3.263 0 0 1 3 22.552L13.316 4.243c.559-1.005 1.559-1.599 2.69-1.599 1.125 0 2.131.6 2.69 1.606L29.005 22.56a3.22 3.22 0 0 1-.02 3.177zM14 9.112c.048.596.087 1.2.135 1.795.134 2.27.269 4.495.404 6.766.047.769.673 1.327 1.48 1.327.809 0 1.442-.596 1.482-1.373 0-.467 0-.897.048-1.372.087-1.456.182-2.912.269-4.367.047-.943.134-1.886.182-2.829 0-.339-.048-.64-.182-.942-.404-.845-1.347-1.275-2.29-1.064C14.587 7.31 14 8.124 14 9.113z"/>
</template>

<script>
export default {
    name: 'warningIcon',
    beforeMount() {
        this.$parent.$emit('size', '0 0 32 30');
    }
};
</script>
